/* ALNASHIR — PRODUCT PAGE
   يُحمّل بـ defer، فيُنفّذ بعد اكتمال تحليل المستند. */
(function () {
  if (window.customElements && customElements.get('alnashir-product')) return;

  class AlnashirProduct extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      var self = this;
      this.data = this.readJson('[data-apx-variants]') || [];
      this.money = this.dataset.moneyFormat || '{{amount}}';

      this.form = this.querySelector('[data-apx-form]');
      this.idInput = this.querySelector('[data-apx-id]');
      this.qtyInput = this.querySelector('[data-apx-qty]');
      this.priceNow = this.querySelector('[data-apx-price]');
      this.priceWas = this.querySelector('[data-apx-was]');
      this.saveTag = this.querySelector('[data-apx-save]');
      this.stockEl = this.querySelector('[data-apx-stock]');
      this.skuEl = this.querySelector('[data-apx-sku]');
      this.cartBtn = this.querySelector('[data-apx-add]');
      this.buyBtn = this.querySelector('[data-apx-buy]');
      this.barPrice = this.querySelector('[data-apx-bar-price]');
      this.bar = this.querySelector('[data-apx-bar]');
      this.zoomPausedUntil = 0;

      this.initGallery();
      this.initOptions();
      this.initQty();
      this.initTabs();
      this.initBar();

      this.addEventListener('submit', function (e) {
        if (!e.target.closest('[data-apx-form]')) return;
        e.preventDefault();
        self.addToCart(false);
      });

      if (this.buyBtn) {
        this.buyBtn.addEventListener('click', function (e) {
          e.preventDefault();
          self.addToCart(true);
        });
      }

      var current = this.currentVariant();
      if (current) this.apply(current);
    }

    readJson(sel) {
      var el = this.querySelector(sel);
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    /* ---------- المعرض ---------- */
    initGallery() {
      var self = this;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-apx-slide]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-apx-thumb]'));
      this.stage = this.querySelector('[data-apx-stage]');
      this.index = 0;

      this.thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          self.show(i, true);
        });
      });

      var prev = this.querySelector('[data-apx-gprev]');
      var next = this.querySelector('[data-apx-gnext]');
      if (prev) prev.addEventListener('click', function () {
        self.show(self.index - 1, true);
      });
      if (next) next.addEventListener('click', function () {
        self.show(self.index + 1, true);
      });

      if (this.slides.length < 2) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
      }

      /* تكبير بتتبّع المؤشر — على أجهزة التأشير فقط */
      if (this.stage && window.matchMedia('(hover: hover)').matches) {
        this.stage.addEventListener('pointerover', function (e) {
          if (!self.isZoomControl(e.target)) return;
          self.stage.classList.remove('is-zoom');
        }, true);
        this.stage.addEventListener('mouseenter', function (e) {
          if (self.isZoomControlAtPoint(e)) {
            self.stage.classList.remove('is-zoom');
            return;
          }
          if (self.isZoomPaused()) {
            setTimeout(function () {
              if (!self.isZoomPaused() && self.stage && self.stage.matches(':hover') && !self.isZoomControlAtPointer()) {
                self.stage.classList.add('is-zoom');
              }
            }, Math.max(0, self.zoomPausedUntil - Date.now()));
            return;
          }
          self.stage.classList.add('is-zoom');
        });
        this.stage.addEventListener('mouseleave', function () {
          self.stage.classList.remove('is-zoom');
          self.slides.forEach(function (s) { s.style.transformOrigin = 'center center'; });
        });
        this.stage.addEventListener('mousemove', function (e) {
          self.lastPointerX = e.clientX;
          self.lastPointerY = e.clientY;
          if (self.isZoomControl(e.target) || self.isZoomPaused()) {
            self.stage.classList.remove('is-zoom');
            return;
          }
          self.stage.classList.add('is-zoom');
          var r = self.stage.getBoundingClientRect();
          var x = ((e.clientX - r.left) / r.width) * 100;
          var y = ((e.clientY - r.top) / r.height) * 100;
          var active = self.slides[self.index];
          if (active) active.style.transformOrigin = x + '% ' + y + '%';
        });
      }

      /* السحب بالإصبع على الصورة */
      if (this.stage) {
        var sx = 0, moved = false;
        this.stage.addEventListener('touchstart', function (e) {
          sx = e.touches[0].clientX; moved = false;
        }, { passive: true });
        this.stage.addEventListener('touchmove', function (e) {
          if (Math.abs(e.touches[0].clientX - sx) > 40) moved = true;
        }, { passive: true });
        this.stage.addEventListener('touchend', function (e) {
          if (!moved) return;
          var dx = e.changedTouches[0].clientX - sx;
          var rtl = getComputedStyle(self).direction === 'rtl';
          var fwd = rtl ? dx > 0 : dx < 0;
          self.show(self.index + (fwd ? 1 : -1), true);
        });
      }

      /* شبكة أمان: نضمن ظهور شريحة واحدة فعلياً بغض النظر عن ترتيب
         الوسائط في المتجر أو أي حالة سباق أخرى — بدل الاعتماد فقط على
         كلاس is-active المُصيَّر من السيرفر. */
      if (this.slides.length) this.show(0);
    }

    show(i, delayZoom) {
      if (!this.slides.length) return;
      if (delayZoom) this.pauseZoom(600);
      if (i < 0) i = this.slides.length - 1;
      if (i >= this.slides.length) i = 0;
      this.index = i;
      var activeSlide = null;
      this.slides.forEach(function (s, n) {
        var active = n === i;
        s.classList.toggle('is-active', active);
        s.hidden = !active;
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) activeSlide = s;
      });
      this.thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      if (this.stage && activeSlide) {
        this.stage.dataset.activeImageUrl = activeSlide.dataset.fullImageUrl || activeSlide.currentSrc || activeSlide.src;
      }
    }

    showByMedia(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < this.slides.length; i++) {
        if (String(this.slides[i].dataset.mediaId) === String(mediaId)) { this.show(i, true); return; }
      }
    }

    /* ---------- الخيارات ---------- */
    initOptions() {
      var self = this;
      this.optGroups = Array.prototype.slice.call(this.querySelectorAll('[data-apx-opt]'));
      this.optGroups.forEach(function (group) {
        group.addEventListener('click', function (e) {
          var pill = e.target.closest('[data-apx-val]');
          if (!pill) return;
          self.pauseZoom(600);
          Array.prototype.forEach.call(group.querySelectorAll('[data-apx-val]'), function (p) {
            p.classList.toggle('is-on', p === pill);
          });
          self.onChange();
        });
      });
    }

    pauseZoom(ms) {
      var self = this;
      var delay = ms || 600;
      this.zoomPausedUntil = Date.now() + delay;
      if (this.stage) this.stage.classList.remove('is-zoom');
      window.clearTimeout(this.zoomResumeTimer);
      this.zoomResumeTimer = window.setTimeout(function () {
        if (self.stage && self.stage.matches(':hover') && !self.isZoomControlAtPointer()) {
          self.stage.classList.add('is-zoom');
        }
      }, delay + 10);
    }

    isZoomPaused() {
      return Date.now() < (this.zoomPausedUntil || 0);
    }

    isZoomControl(target) {
      return !!(target && target.closest && target.closest('[data-apx-gprev], [data-apx-gnext], [data-apx-thumb]'));
    }

    isZoomControlAtPoint(e) {
      if (!e || typeof document.elementFromPoint !== 'function') return false;
      return this.isZoomControl(document.elementFromPoint(e.clientX, e.clientY));
    }

    isZoomControlAtPointer() {
      if (typeof this.lastPointerX !== 'number' || typeof this.lastPointerY !== 'number') return false;
      return this.isZoomControlAtPoint({ clientX: this.lastPointerX, clientY: this.lastPointerY });
    }

    selected() {
      return this.optGroups.map(function (g) {
        var on = g.querySelector('[data-apx-val].is-on');
        return on ? on.dataset.apxVal : null;
      });
    }

    currentVariant() {
      var picked = this.selected();
      if (!picked.length) return this.data[0];
      for (var i = 0; i < this.data.length; i++) {
        var v = this.data[i], ok = true;
        for (var j = 0; j < picked.length; j++) {
          if (picked[j] !== null && v.options[j] !== picked[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    onChange() {
      var v = this.currentVariant();
      this.apply(v);
      if (v && window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }

    apply(v) {
      var t = this.dataset;

      if (!v) {
        if (this.cartBtn) { this.cartBtn.disabled = true; this.setLabel(this.cartBtn, t.textUnavailable); }
        if (this.buyBtn) this.buyBtn.disabled = true;
        return;
      }

      if (this.idInput) this.idInput.value = v.id;
      if (this.priceNow) this.priceNow.textContent = v.price;
      if (this.barPrice) this.barPrice.textContent = v.price;

      if (this.priceWas) {
        this.priceWas.textContent = v.compare || '';
        this.priceWas.hidden = !v.compare;
      }
      if (this.saveTag) {
        this.saveTag.textContent = v.save || '';
        this.saveTag.hidden = !v.save;
      }
      if (this.skuEl) {
        this.skuEl.textContent = v.sku || '—';
      }

      if (this.stockEl) {
        this.stockEl.classList.toggle('is-in', v.available);
        this.stockEl.classList.toggle('is-out', !v.available);
        this.stockEl.textContent = v.available ? t.textInStock : t.textOutStock;
      }

      if (this.cartBtn) {
        this.cartBtn.disabled = !v.available;
        this.setLabel(this.cartBtn, v.available ? t.textAdd : t.textSoldOut);
      }
      if (this.buyBtn) this.buyBtn.disabled = !v.available;

      this.showByMedia(v.media);
      this.markUnavailable();
    }

    /* شطب الخيارات غير المتوفرة مع الاختيار الحالي */
    markUnavailable() {
      var self = this;
      var picked = this.selected();
      this.optGroups.forEach(function (g, gi) {
        Array.prototype.forEach.call(g.querySelectorAll('[data-apx-val]'), function (p) {
          var trial = picked.slice();
          trial[gi] = p.dataset.apxVal;
          var exists = self.data.some(function (v) {
            for (var j = 0; j < trial.length; j++) {
              if (trial[j] !== null && v.options[j] !== trial[j]) return false;
            }
            return v.available;
          });
          p.classList.toggle('is-off', !exists);
        });
      });
    }

    setLabel(btn, text) {
      var s = btn.querySelector('[data-apx-label]');
      if (s && text) s.textContent = text;
    }

    /* ---------- الكمية ---------- */
    initQty() {
      var self = this;
      var minus = this.querySelector('[data-apx-minus]');
      var plus = this.querySelector('[data-apx-plus]');
      if (minus) minus.addEventListener('click', function () { self.step(-1); });
      if (plus) plus.addEventListener('click', function () { self.step(1); });
    }

    step(n) {
      if (!this.qtyInput) return;
      var v = parseInt(this.qtyInput.value, 10) || 1;
      this.qtyInput.value = Math.max(1, v + n);
    }

    /* ---------- التبويبات ---------- */
    initTabs() {
      var nav = this.querySelector('[data-apx-tabnav]');
      if (!nav) return;
      var self = this;
      nav.addEventListener('click', function (e) {
        var b = e.target.closest('button[data-apx-tab]');
        if (!b) return;
        var key = b.dataset.apxTab;
        Array.prototype.forEach.call(nav.querySelectorAll('button'), function (x) {
          x.classList.toggle('is-on', x === b);
          x.setAttribute('aria-selected', x === b ? 'true' : 'false');
        });
        Array.prototype.forEach.call(self.querySelectorAll('[data-apx-panel]'), function (p) {
          p.classList.toggle('is-on', p.dataset.apxPanel === key);
        });
      });
    }

    /* ---------- شريط الجوال ---------- */
    initBar() {
      if (!this.bar || !this.cartBtn || !('IntersectionObserver' in window)) return;
      var bar = this.bar;
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-up', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -80px 0px' }).observe(this.cartBtn);

      var self = this;
      var barBtn = this.querySelector('[data-apx-bar-add]');
      if (barBtn) {
        barBtn.addEventListener('click', function () {
          self.cartBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
          self.addToCart(false);
        });
      }
    }

    /* ---------- السلة ---------- */
    addToCart(goCheckout) {
      var self = this;
      if (this._busy || !this.form) return;
      var btn = goCheckout ? this.buyBtn : this.cartBtn;
      if (!btn || btn.disabled) return;
      this._busy = true;
      btn.classList.add('is-loading');

      fetch(this.dataset.cartAdd || '/cart/add', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(this.form)
      })
        .then(function (res) {
          return res.json().catch(function () { return null; }).then(function (d) {
            if (!res.ok) throw new Error((d && (d.description || d.message)) || 'fail');
            return d;
          });
        })
        .then(function (added) {
          btn.classList.remove('is-loading');
          if (goCheckout) {
            window.location.href = (self.dataset.cartUrl || '/cart').replace(/\/cart\/?$/, '/checkout');
            return;
          }
          btn.classList.add('is-done');
          self.setLabel(btn, self.dataset.textAdded);
          self.bumpCartCount(Number(added && added.quantity) || 1);
          self.syncCart();
          setTimeout(function () {
            btn.classList.remove('is-done');
            self.setLabel(btn, self.dataset.textAdd);
            self._busy = false;
          }, 1900);
        })
        .catch(function () {
          btn.classList.remove('is-loading');
          self.setLabel(btn, self.dataset.textError);
          setTimeout(function () {
            self.setLabel(btn, self.dataset.textAdd);
            self._busy = false;
          }, 2000);
        });
    }

    bumpCartCount(amount) {
      var nodes = document.querySelectorAll(
        '[data-cart-count], .cart-count-bubble span:first-child, .cart-count, #CartCount, .site-header__cart-count'
      );
      for (var i = 0; i < nodes.length; i++) {
        if (!/^\s*\d*\s*$/.test(nodes[i].textContent)) continue;
        nodes[i].textContent = (Number(nodes[i].textContent) || 0) + amount;
      }
    }

    syncCart() {
      var base = this.dataset.cartUrl || '/cart';
      fetch(base + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var nodes = document.querySelectorAll(
            '[data-cart-count], .cart-count-bubble span:first-child, .cart-count, #CartCount, .site-header__cart-count'
          );
          for (var i = 0; i < nodes.length; i++) {
            if (!/^\s*\d*\s*$/.test(nodes[i].textContent)) continue;
            nodes[i].textContent = cart.item_count;
          }
          ['cart:refresh', 'cart:updated', 'cart:build'].forEach(function (n) {
            document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } }));
          });
        })
        .catch(function () {});
    }
  }

  customElements.define('alnashir-product', AlnashirProduct);
})();
